import { string, object, func, bool } from 'prop-types'
import { Fragment } from 'react'
import { AccountName } from '../../../../AccountName'
import { ContentAvatar } from '../../../../ContentAvatar'
import { ContentTextInput } from '../../../../ContentTextInput'
import { styles } from './styles'

export const AssetAndCopyHeader = ({
  accountImage,
  accountName,
  content,
  onContentChange,
  readOnly,
}) => {
  return (
    <Fragment>
      <div style={styles.headerWrapper}>
        <div style={styles.flexRow}>
          <ContentAvatar
            assetReference={accountImage}
            size={40}
            borderRadius="0"
          />
          <div style={styles.header}>
            <AccountName
              name={accountName}
              size={14}
              color="#050505"
              style={styles.accountName}
            />
          </div>
        </div>
      </div>
      <div style={styles.contentWrapper}>
        <ContentTextInput
          placeholder="Add copy..."
          readOnly={readOnly}
          value={content}
          highlightSocialTags={true}
          characterLimit={63206}
          onChange={(val) => onContentChange(val)}
        />
      </div>
    </Fragment>
  )
}

AssetAndCopyHeader.propTypes = {
  accountImage: object,
  accountName: string,
  content: string,
  onContentChange: func,
  readOnly: bool,
}
